import { ChevronRight } from 'react-feather'
import clsx from 'clsx'
import { Button, Tag } from '@/components'
import { AlertMessage } from '@/app/components'
import { Text } from '@/components'
import { ThermostatBrand, VehicleBrand } from '@/types/brand'
import { match } from 'ts-pattern'

function RightCardSide({ comingSoon }: { comingSoon: boolean }) {
  if (comingSoon) {
    return (
      <span className="ml-auto">
        <span className="text-sm opacity-50 align-middle inline">
          Coming Soon!
        </span>
      </span>
    )
  }

  return (
    <span className="ml-auto">
      <ChevronRight className="text-gray-400 text-xl" />
    </span>
  )
}

const BrandCard = ({
  make,
  onClick,
  index,
  arrayLength,
  id,
  includeName = true,
  comingSoon = false,
  backSoon = false,
  ineligible = false,
  includeLastBorder = false,
  warningMessage = '',
}: {
  make: VehicleBrand | ThermostatBrand
  onClick: (make: VehicleBrand | ThermostatBrand) => void
  index?: number
  arrayLength?: number
  id: string
  includeName?: boolean
  comingSoon?: boolean
  backSoon?: boolean
  ineligible?: boolean
  includeLastBorder?: boolean
  warningMessage?: string
}) => {
  const isComingSoon = comingSoon || backSoon

  const handleClick = () => {
    if (!backSoon) {
      onClick(make)
    }
  }

  const isLastElement = () => {
    if ((index && arrayLength) || arrayLength === 1) {
      if (index === arrayLength - 1) return true
      return false
    }
    return false
  }

  const borderStyle =
    isLastElement() && !includeLastBorder
      ? {}
      : { borderBottom: '1px solid #E5E5E5' }

  return (
    <div>
      <Button
        variant="click-wrapper"
        onClick={handleClick}
        data-testing-id={`brand-card-${make.name.toLowerCase()}`}
        id={`${id}-brand-card-${make.name.toLowerCase()}`}
      >
        <div
          className={clsx(
            'group flex py-2 items-center cursor-pointer transition-colors duration-200',
            {
              'pointer-events-none': isComingSoon,
            },
            index === 0 ? 'pb-4' : 'py-4',
          )}
          style={borderStyle}
        >
          <div className="w-1/6 h-[70px] flex items-center justify-center">
            <img
              className={clsx(
                'h-[30px] object-contain max-h-[60%] max-w-[80%] w-auto h-auto',
                {
                  'grayscale opacity-50': isComingSoon,
                },
              )}
              src={make.logo}
              alt={make.name}
            />
          </div>
          {includeName && (
            <Text
              className={clsx('pl-5 !text-[15px] group-hover:!text-blue-500', {
                'opacity-50': isComingSoon,
              })}
              variant="body1"
            >
              {make.name}
            </Text>
          )}
          {match({ ineligible, backSoon })
            .with({ ineligible: true }, () => (
              <Tag className="ml-4" color="themed-grey-200">
                <Text variant="body5" className="mx-2 text-base-grey-500">
                  Ineligible
                </Text>
              </Tag>
            ))
            .with({ backSoon: true }, () => (
              <Tag className="ml-4" color="themed-blue-100">
                <Text variant="body5" className="mx-2 text-themed-blue-500">
                  Coming Soon
                </Text>
              </Tag>
            ))
            .otherwise(() => null)}
          <RightCardSide comingSoon={comingSoon} />
        </div>
      </Button>
      {warningMessage && (
        <AlertMessage variant="warning">{warningMessage}</AlertMessage>
      )}
    </div>
  )
}

export default BrandCard
